import { ComponentWithAs, Icon, IconProps } from '@chakra-ui/react'

const IconComp: ComponentWithAs<'svg', IconProps> = ({
  children,
  ...props
}) => {
  return (
    <Icon {...props}>
      <path
        d="M5 4C4.44772 4 4 4.44772 4 5C4 5.55228 4.44772 6 5 6V4ZM19 6C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4V6ZM5 6H19V4H5V6Z"
        fill="#A5ABAB"
      ></path>
      <path
        d="M7 8.99561C7 8.44332 6.55228 7.99561 6 7.99561C5.44772 7.99561 5 8.44332 5 8.99561H7ZM19 8.99561C19 8.44332 18.5523 7.99561 18 7.99561C17.4477 7.99561 17 8.44332 17 8.99561H19ZM17 8.99561V16H19V8.99561H17ZM14 19H10V21H14V19ZM7 16V8.99561H5V16H7ZM10 19C8.34315 19 7 17.6568 7 16H5C5 18.7614 7.23858 21 10 21V19ZM17 16C17 17.6568 15.6569 19 14 19V21C16.7614 21 19 18.7614 19 16H17Z"
        fill="#A5ABAB"
      ></path>
      <path
        d="M9 14C9 14.5523 9.44772 15 10 15C10.5523 15 11 14.5523 11 14L9 14ZM11 11.0886C11 10.5363 10.5523 10.0886 10 10.0886C9.44772 10.0886 9 10.5363 9 11.0886L11 11.0886ZM11 14L11 11.0886L9 11.0886L9 14L11 14Z"
        fill="#A5ABAB"
      ></path>
      <path
        d="M13 14C13 14.5523 13.4477 15 14 15C14.5523 15 15 14.5523 15 14L13 14ZM15 11.0886C15 10.5363 14.5523 10.0886 14 10.0886C13.4477 10.0886 13 10.5363 13 11.0886L15 11.0886ZM15 14L15 11.0886L13 11.0886L13 14L15 14Z"
        fill="#A5ABAB"
      ></path>
      <path
        d="M10 3C9.44772 3 9 3.44772 9 4C9 4.55228 9.44772 5 10 5L10 3ZM14 5C14.5523 5 15 4.55229 15 4C15 3.44772 14.5523 3 14 3L14 5ZM10 5L14 5L14 3L10 3L10 5Z"
        fill="#A5ABAB"
      ></path>
    </Icon>
  )
}
IconComp.defaultProps = {
  viewBox: '0 0 24 24',
  boxSize: '24px',
}

export default IconComp
